class App {
  constructor() {
    this.searchMenu()
    this.personal()
  }

  searchMenu () {
    try {
      let iconSearch = document.querySelector('#header .icon-search')
      let iconQuit = document.querySelector('#header .icon-quit')
      let formSearch = document.querySelector('#header .form-search')
      let menu = document.querySelector('#header .menu')

      iconSearch.addEventListener('click', () => {
        iconSearch.classList.toggle('hidden')
        iconQuit.classList.toggle('hidden')
        formSearch.classList.toggle('hidden')
        menu.classList.toggle('hidden')
        formSearch.querySelector('input').focus()
      })
      iconQuit.addEventListener('click', () => {
        iconQuit.classList.toggle('hidden')
        iconSearch.classList.toggle('hidden')
        formSearch.classList.toggle('hidden')
        menu.classList.toggle('hidden')
      })

    } catch (error) {

    }
  }

  personal () {
    try {
      let personal = document.querySelector('.personal')

      personal?.querySelectorAll('.parent').forEach(prt => {
        let child = prt.querySelector('.child')
        prt.addEventListener('click', () => {
            child.classList.toggle('hidden')
          })
      });

    } catch (error) {

    }
  }

}

export default window.addEventListener('DOMContentLoaded', () => {
  new App()
})